import React from "react";
import {Select} from "antd";

var CONST_LANGUE_LOCAL_STORAGE = 'LanguageFront';

const Option = Select.Option;


export function setLanguage(pe_language) {

  localStorage.setItem(CONST_LANGUE_LOCAL_STORAGE, pe_language);

  return pe_language;

}


export function getLanguage() {

  let item = localStorage.getItem(CONST_LANGUE_LOCAL_STORAGE);

  if (!item) {
    item = crypto.randomUUID();
    localStorage.setItem(CONST_LANGUE_LOCAL_STORAGE, 'fr');
  }
  
  return item;

}




export function getPays() {

   // Liste des langues avec leur code et le drapeau correspondant
  let languages = [
    { code: 'fr', label: 'Français', flag: '🇫🇷' },
    { code: 'en', label: 'English', flag: '🇬🇧' },
    { code: 'de', label: 'Deutsch', flag: '🇩🇪' },
    { code: 'es', label: 'Español', flag: '🇪🇸' },
    { code: 'it', label: 'Italiano', flag: '🇮🇹' },
    { code: 'pt-PT', label: 'Português', flag: '🇵🇹' },
  ];

  /*
   languages = [
    { code: 'fr', label: 'Français', flag: '🇫🇷' }
  ];*/

  return languages;
}


export function redirectToHome() {
  window.location.href= '/';
}


export function verifIsLogged(){

  let guid_compte = getMachineId();

  if(guid_compte == null){
    window.location.href= '/login';
  }
}


export function getBaseURL(){

  let baseURL = process.env.REACT_APP_URL;

  if(baseURL == undefined) {
    baseURL = 'http://127.0.0.1:9070';
  }

  return baseURL;

}


export function getMachineId() {

    let machineId = localStorage.getItem('MachineIdUnique');

    /*
    On désactive la création de machineId sur la version desjoyaux
    if (!machineId) {
        machineId = crypto.randomUUID();
        localStorage.setItem('MachineIdUnique', machineId);
    }
    */

    return machineId;
}


export function setMachineId() {

  let machineId = localStorage.getItem('MachineIdUnique');

  
  //On désactive la création de machineId sur la version desjoyaux
  if (!machineId) {
      machineId = crypto.randomUUID();
      localStorage.setItem('MachineIdUnique', machineId);
  }
  

  return machineId;
}


export function setDisconnectMachineId() {

  localStorage.removeItem('MachineIdUnique');
  window.location.href= '/';
  return true;
}


export function cleanJSONContent(data) {

  if(data === null || data === "" || data === undefined) {
    return [];
  }

  return JSON.parse(JSON.stringify(eval("(" + data + ")")))
}


export function parseJSONItem(list, itemName) {

  for(var i in list) {
    list[i][itemName] = cleanJSONContent(list[i][itemName]);
  }
  return list;
}


export function addAlpha(color, opacity) {

    // coerce values so ti is between 0 and 1.
    var _opacity = Math.round(Math.min(Math.max(opacity || 1, 0), 1) * 255);
    return color + _opacity.toString(16).toUpperCase();
}


export function getTypeArticleOption() {

  var list = [];
  list.push(<Option key={1} value={1}>Poudre</Option>);
  list.push(<Option key={2} value={2}>Liquide</Option>);
  return list;
}


export function getFrDateFormat(date) {

  console.log(date);

  if(date === undefined || date === null)
    return null;
  return formatDate(new Date(date),'dd/MM/yyyy');
}

export function formatDate(x, y) {
  if (!(x instanceof Date)) x = new Date(x);
  if (isNaN(x.getTime())) return null;
  if (x.getTime() === 0) return null;
  if (x.getFullYear() === 1970) return '-';

  const z = {
    M: x.getMonth() + 1,
    d: x.getDate(),
    h: x.getHours(),
    m: x.getMinutes(),
    s: x.getSeconds()
  };

  y = y.replace(/(M+|d+|h+|m+|s+)/g, function(v) {
    const val = z[v.slice(-1)];
    return val.toString().padStart(v.length, '0');
  });

  return y.replace(/(y+)/g, function(v) {
    return x.getFullYear().toString().slice(-v.length);
  });
}


export function formatDate_OLD(x, y) {

  if(x.getTime() === 0)
    return null;
  if(x.getFullYear() === 1970)
    return '-'

  y = y.replace(/(M+|d+|h+|m+|s+)/g, function(v) {
      console.log(v)
      return ((v.length > 1 ? "0" : "") + eval('z.' + v.slice(-1))).slice(-2)
  });

  return y.replace(/(y+)/g, function(v) {
      return x.getFullYear().toString().slice(-v.length)
  });
}


export function getColorWithState(state) {

  let color = '';

  switch (state) {

    case 'BON':
      color = 'green'
      break;
    case 'MOYEN':
      color = 'orange'
      break;
    case 'MAUVAIS':
      color = 'red'
      break;
    default:
  }

  return color;

}
